import { render, staticRenderFns } from "./user_grade_list.vue?vue&type=template&id=5d311b45&scoped=true&"
import script from "./user_grade_list.vue?vue&type=script&lang=js&"
export * from "./user_grade_list.vue?vue&type=script&lang=js&"
import style0 from "./user_grade_list.vue?vue&type=style&index=0&id=5d311b45&lang=less&scoped=true&"
import style1 from "./user_grade_list.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d311b45",
  null
  
)

export default component.exports